import React, { Component } from 'react'
import { compose } from 'react-apollo'
import Styled from 'styled-components'

import { getValidationErrors } from 'helpers/validation'

import PageLoader from 'components/PageLoader'
import NotFound from 'components/NotFound'
import Content from 'components/Content'
import ProjectInfoUI from 'components/ProjectInfoUI'
import ProjectDangerZoneUI from 'components/ProjectDangerZoneUI'

import {
  settings as settingsQuery
} from 'components/Settings/queries'

import {
  updateProject as updateProjectMutation
} from 'components/Settings/mutations'

const Main = Styled.div`
  padding: 3rem 0;
`

class Settings extends Component {
  state = { // eslint-disable-line
    __projectId: null,

    inputs: {
      name: '',
      url: ''
    },

    errors: {
      name: [],
      url: [],
      general: []
    },

    isUpdating: false
  }

  static getDerivedStateFromProps(props, state) {
    if (props.loading) {
      return null
    }

    if (!props.project) {
      return null
    }

    if (state.__projectId === props.project._id) {
      return null
    }

    return {
      ...state,
      __projectId: props.project._id,
      inputs: {
        name: props.project.name,
        url: props.project.url
      }
    }
  }

  handleInputChange = (key, value) => {
    this.setState({
      inputs: {
        ...this.state.inputs,
        [key]: value
      }
    })
  }

  handleUpdate = async () => {
    try {
      this.setState({
        isUpdating: true,
        errors: {
          name: [],
          url: [],
          general: []
        }
      })

      await this.props.updateProject({
        projectId: this.props.project._id,
        name: this.state.inputs.name,
        url: this.state.inputs.url
      })

      this.setState({
        isUpdating: false
      })
    } catch (error) {
      this.setState({
        isUpdating: false,
        errors: {
          ...this.state.errors,
          ...getValidationErrors(error)
        }
      })
    }
  }

  render() {
    if (this.props.loading) {
      return <PageLoader />
    }

    if (!this.props.project) {
      return <NotFound />
    }

    return (
      <Main>
        <Content>
          <ProjectInfoUI
            isUpdating={this.state.isUpdating}

            nameValue={this.state.inputs.name}
            nameErrors={this.state.errors.name}
            onNameChange={value => this.handleInputChange('name', value)}

            urlValue={this.state.inputs.url}
            urlErrors={this.state.errors.url}
            onUrlChange={value => this.handleInputChange('url', value)}

            generalErrors={this.state.errors.general}

            onSubmit={this.handleUpdate}
          />


          <ProjectDangerZoneUI
            project={this.props.project}
          />
        </Content>
      </Main>
    )
  }
}

export default compose(
  settingsQuery,
  updateProjectMutation
)(Settings)



// WEBPACK FOOTER //
// ./src/components/Settings/index.js